import { CLOUD_BETA_URL, ROUTE_BETA_URL, ROUTE_LOCAL_URL, ROUTE_PROD_URL } from '../constants/url.constants'

const hostname = window?.location?.hostname

export const isBeta = (): boolean => hostname === CLOUD_BETA_URL

export const isLocal = (): boolean => hostname === 'localhost' || hostname === '127.0.0.1'

export const byEnv = <T>(values: { local: T; beta: T; prod: T }): T => {
  if (isLocal()) return values.local
  if (isBeta()) return values.beta
  return values.prod
}

export const getRouteBaseUrl = (): string =>
  byEnv({
    local: `http://${ROUTE_LOCAL_URL}`,
    beta: `https://${ROUTE_BETA_URL}`,
    prod: `https://${ROUTE_PROD_URL}`,
  })
